import {appRouter} from '@netx/core-next/instance/router';
import {session} from '@netx/core-auth/collections/singleton/session';
import {useCallback, useRef, useState} from 'react';
import {useReactQueryChangePassword} from '../api';
import {AuthMessage} from '../locales';

export const useResetPassword = () => {
	const [passwordReset, setPasswordReset] = useState(false);
	const isPasswordUpdate = useRef(false);

	const resetPasswordMutation = useReactQueryChangePassword({
		onError(err) {
			// dispatcher.trigger('auth:user:password:request:error', err);
		},
		onSuccess() {
			setPasswordReset(true);
			if (isPasswordUpdate.current) {
				session.set({
					loginMsg: AuthMessage.PASSOWRD_UPDATED_SIGNIN_REQUIRED,
				});
				appRouter.navigate('login', true);
			}
		},
	});

	const resetPassword = useCallback(
		async (params: Parameters<typeof resetPasswordMutation.mutateAsync>[0]) => {
			isPasswordUpdate.current = params.token != null;
			return resetPasswordMutation.mutateAsync(params);
		},
		[],
	);

	return {
		passwordReset,
		error: resetPasswordMutation.error,
		resettingPassword: resetPasswordMutation.isLoading,

		resetPassword,
	};
};

export default useResetPassword;
